export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgIi9hc3NldHMvbG9nby5kMGM5ZmJlMy5jNjU3OGFmMS0yMTI2LTRlOTYtYjI1MS02OGUwYzg2YWYwNGQucG5nIjs="